import React, { useEffect, useState } from "react";
import { searchBusinessChallenge } from "services/serp";
import { entityType, filtersMyracle } from "utils/commons";
import SearchView from "components/SearchView";
import useLoadData from "../../hooks/useLoadData";
import "./style.scss";

const BusinessChallenges = ({
  searchPreset,
  setSearch,
  updateCount,
  handleResetQ,
  callback,
}) => {
  const [selectedFilters, setSelectedFilters] = useState({
    order_by: "RANKING",
    ...searchPreset,
  });

  const {
    loadData,
    items: businessChallenges,
    setItems: setBusinessChallenges,
    total,
    setPageNumber,
  } = useLoadData({
    searchFunction: searchBusinessChallenge,
    params: { ...selectedFilters },
  });

  const handleResetFilters = () => {
    setPageNumber(0);
    setBusinessChallenges([]);

    setSearch("count", { businessChallenges: 0 });
    const initialFilter = {
      order_by: "RANKING",
    };

    setSelectedFilters(initialFilter);
    setSearch("businessChallenges", initialFilter);
    handleResetQ("businessChallenges");
  };

  const handleChangeFilter = (key, value) => {
    setPageNumber(0);
    setBusinessChallenges([]);
    setSelectedFilters({
      ...selectedFilters,
      [key]: value,
    });
    setSearch("businessChallenges", {
      ...selectedFilters,
      [key]: value,
    });
  };

  useEffect(() => {
    updateCount("businessChallenges", total);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total]);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  useEffect(() => {
    setPageNumber(0);
    const newFilter = { ...selectedFilters, ...searchPreset };
    if (JSON.stringify(selectedFilters) === JSON.stringify(newFilter)) {
      return;
    }
    setSelectedFilters({ ...selectedFilters, ...searchPreset });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchPreset]);

  return (
    <SearchView
      selectedFilters={selectedFilters}
      handleChangeFilter={handleChangeFilter}
      dataList={businessChallenges}
      viewableFilters={filtersMyracle.BUSINESS_CHALLENGES}
      isSerp
      handleResetFilters={handleResetFilters}
      callback={callback}
      documentType={entityType.BUSINESS_CHALLENGE}
      loadData={loadData}
      total={total}
    />
  );
};

export default BusinessChallenges;
